import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Pay Down Debt or Invest Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/pay-debt-invest/" title="Pay Down Debt or Invest Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
